import React from "react";
import { buildServiceUrl } from "../src/utils/urlBuilder";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import "./index.css";
import "./i18n";
import { registerCacheWorker } from "./serviceWorkerRegister";
import { WorkerProvider } from "./utils/workerContext";
import { appConfig } from "./utils/config";
import { ThemeProvider } from "@emotion/react";
import { theme } from "./theme";
import { runtimeEnv } from "./utils/runtimeEnv";

const redirectBase = `${window.location.origin}/home`;

document.documentElement.style.setProperty(
  "--main-color",
  appConfig.colors.main,
);
document.documentElement.style.setProperty(
  "--secondary-color",
  appConfig.colors.secondary,
);
document.documentElement.style.setProperty(
  "--third-color",
  appConfig.colors.third,
);
document.documentElement.style.setProperty(
  "--fourth-color",
  appConfig.colors.fourth,
);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

const authConfig = {
  client_id: runtimeEnv.REACT_APP_CLIENT_ID,
  authority: `${buildServiceUrl("keycloak", "/realms/DSB", {
    useRuntimePort: false,
  })}`,
  redirect_uri: redirectBase,
  post_logout_redirect_uri: redirectBase,
  scope: runtimeEnv.REACT_APP_SCOPE,
  automaticSilentRenew: true,
  onSigninCallback: () =>
    window.history.replaceState({}, document.title, window.location.pathname),
};

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <AuthProvider {...authConfig}>
        <WorkerProvider>
          <App />
        </WorkerProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
registerCacheWorker();
